import _ from 'lodash';

import { UpdateOpenOrdersEnum } from 'Common/FieldEnum';
import { TypeEnum } from 'Common/Constants/Enumeration/UpdateOpenOrderEnum';
import {
  getPriSecInDecimalFormat,
  getPriSecDetail,
} from './../../helper/updateOpenOrders';
import * as types from './types';

const INITIAL_STATE = {
  siteGroupData: [],
  warehouseKitchenData: [],
  openOrderDetailData: [],
  isFetchingSiteGroup: false,
  itemList: [],
  submitted: false,
  updateOrderResponseError: null,
  loading: false,
  isFetchingItemList: false,
  submitting: false,
  totalPrimary: 0,
  totalSecondary: 0,
  totalRemaining: '',
  WarehouseAvlbQuantity: 0,
  isTotalExceed: false,
  fetchingSiteGroupError: null,
  warehouseKitchenDataError: null,
  itemListError: null,
  kitchenData: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SITE_GROUP_DATA_LIST: {
      return {
        ...state,
        siteGroupData: action.payload,
      };
    }

    case types.SITE_GROUP_DATA_LIST_ERROR: {
      return {
        ...state,
        fetchingSiteGroupError: action.payload,
      };
    }

    case types.SITE_GROUP_DATA_LOADING: {
      return {
        ...state,
        isFetchingSiteGroup: action.payload,
      };
    }
    case types.WAREHOUSE_KITCHEN_DATA_LIST: {
      const kitchenData = _.filter(action.payload, [
        UpdateOpenOrdersEnum.SiteMasterTypeId,
        3,
      ]);
      return {
        ...state,
        warehouseKitchenData: action.payload,
        kitchenData: kitchenData,
      };
    }
    case types.WAREHOUSE_KITCHEN_DATA_ERROR: {
      return {
        ...state,
        warehouseKitchenDataError: action.payload,
      };
    }
    case types.ITEM_DATA_LIST: {
      return {
        ...state,
        itemList: action.payload,
      };
    }
    case types.ITEM_DATA_ERROR: {
      return {
        ...state,
        itemListError: action.payload,
      };
    }
    case types.OPEN_ORDER_DETAIL_DATA: {
      return {
        ...state,
        openOrderDetailData: action.payload.Data
          ? action.payload.Data[UpdateOpenOrdersEnum.UpdateOpenOrderCollection]
          : [],
        WarehouseAvlbQuantity: action.payload.Data
          ? action.payload.Data[UpdateOpenOrdersEnum.WarehouseAvlbQuantity]
          : 0,
        isTotalExceed: false,
      };
    }

    case types.OPEN_ORDER_CHECKALL_DATA: {
      const copiedData = _.cloneDeep(state.openOrderDetailData);
      copiedData.forEach(x => {
        const foundRow = _.find(action.payload.currentRows, {
          OrderNumber: x.OrderNumber,
        });
        if (foundRow) {
          x.Allowed = action.payload.checkAll;
        }
      });
      return {
        ...state,
        openOrderDetailData: copiedData,
      };
    }

    case types.OPEN_ORDER_UPDATE_DATA: {
      const copiedData = _.cloneDeep(state.openOrderDetailData);
      const item = _.find(copiedData, {
        OrderNumber: action.payload.OrderNumber,
      });

      if (!item) {
        return state;
      }

      item.Allowed = !action.payload.Allowed;

      return {
        ...state,
        openOrderDetailData: copiedData,
      };
    }
    case types.CHANGE_ROW_VALUE:
      let dataCopy = _.cloneDeep(state.openOrderDetailData);
      const obj = action.payload;
      dataCopy[obj.index][obj.col] = obj.val;

      const primaryTotal = _.sumBy(dataCopy, d => Number(d.AddQtyPrimary));
      const secondaryTotal = _.sumBy(dataCopy, d => Number(d.AddQtySecondary));

      const totalSec = secondaryTotal % obj.qtyPerUnit;
      const integerPart = Math.floor(secondaryTotal / obj.qtyPerUnit);
      const totalPri = primaryTotal + integerPart;

      return {
        ...state,
        totalPrimary: totalPri,
        totalSecondary: totalSec,
      };

    case types.CALCULATE_REMAINING_QTY:
      const {
        index,
        col,
        val,
        qtyPerUnit,
        unitValue,
        secondaryUnitValue,
        isTypeOptionSelected,
      } = action.payload;
      let openOrderDetailDataCopy = _.cloneDeep(state.openOrderDetailData);
      openOrderDetailDataCopy[index][col] = val;

      const calculateArray = _.map(openOrderDetailDataCopy, d => {
        return Number(
          getPriSecInDecimalFormat(
            d.AddQtyPrimary,
            d.AddQtySecondary,
            qtyPerUnit
          )
        );
      });
      const decQty = _.sum(calculateArray);
      const checkCondition = decQty > state.WarehouseAvlbQuantity;
      checkCondition &&
        isTypeOptionSelected === TypeEnum.OpenReceipts &&
        (openOrderDetailDataCopy[index][col] = '');

      const availableQty = checkCondition
        ? state.WarehouseAvlbQuantity
        : state.WarehouseAvlbQuantity - decQty;
      const updated = getPriSecDetail(
        availableQty,
        qtyPerUnit,
        unitValue,
        secondaryUnitValue
      );
      return {
        ...state,
        openOrderDetailData: openOrderDetailDataCopy,
        totalRemaining: updated,
        isTotalExceed: checkCondition,
      };

    case types.OPEN_ORDER_UPDATE_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
        openOrderDetailData: [],
      };

    case types.OPEN_ORDER_UPDATE_DETAIL_ERROR:
      return {
        ...state,
        updateOrderResponseError: action.payload,
      };

    case types.OPEN_ORDER_DATA_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.ITEM_DATA_LOADING: {
      return {
        ...state,
        isFetchingItemList: action.payload,
      };
    }

    case types.SUBMITTING_OPEN_ORDER_LOADING:
      return {
        ...state,
        submitting: action.payload,
      };

    case types.CLEAR_RUNNING_TOTAL:
      return {
        ...state,
        totalPrimary: 0,
        totalSecondary: 0,
        totalRemaining: '',
      };
    case types.SET_SHOW_FLAG:
      return {
        ...state,
        isTotalExceed: action.payload,
      };

    case types.SET_REMAINING_VALUE:
      const { secondaryUnitVal, unitVal, qtyPerUnitVal } = action.payload;
      return {
        ...state,
        totalRemaining: getPriSecDetail(
          state.WarehouseAvlbQuantity,
          qtyPerUnitVal,
          unitVal,
          secondaryUnitVal
        ),
      };

    case types.CLEAR_OPEN_ORDER_ERROR:
      return {
        ...state,
        updateOrderResponseError: null,
        submitted: false,
        fetchingSiteGroupError: null,
        warehouseKitchenDataError: null,
        itemListError: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/updateopenorders/reducer.js